import { useEffect, useState } from 'react';
import ChevronLeft from 'components/src/svg/ChevronLeft';
import ChevronRight from 'components/src/svg/ChevronRight';
import { ImageAsset } from '@/clients/queries/webstore/Webstore';

function ImageGallery({ images, discountBadge }: { images: ImageAsset[]; discountBadge?: React.ReactNode }) {
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    setActiveIdx(0);
  }, [images]);

  const safeIdx = Math.min(activeIdx, Math.max(images.length - 1, 0));
  const active = images[safeIdx];

  const prev = () => setActiveIdx((i) => (images.length ? (i - 1 + images.length) % images.length : 0));
  const next = () => setActiveIdx((i) => (images.length ? (i + 1) % images.length : 0));

  if (!active) {
    return (
      <div className="flex min-h-[320px] w-full items-center justify-center rounded bg-red-100">
        <h3 className="text-lg font-semibold">Myndir koma síðar</h3>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col items-center">
      <div className="relative flex h-fit min-h-[320px] w-full items-center justify-center">
        <div className="bg-white shadow relative flex h-fit max-h-[320px] w-[380px] items-center justify-center overflow-hidden rounded-lg md:max-h-[565px]">
          <img
            src={`${active.url}?w=600&q=80&fm=webp`}
            alt={active.title || 'Vara'}
            className="inset-0 max-h-[320px] object-cover object-center md:max-h-[565px]"
          />
          {discountBadge}
        </div>
        {images.length > 1 && (
          <>
            <button
              type="button"
              onClick={prev}
              className="px-3 shadow absolute left-2 top-1/2 flex h-[40px] w-[40px] -translate-y-1/2 items-center justify-center rounded-full bg-white-15 py-1"
            >
              <ChevronLeft color="#0D0D0D" />
            </button>
            <button
              type="button"
              onClick={next}
              className="px-3 shadow absolute right-2 top-1/2 flex h-[40px] w-[40px] -translate-y-1/2 items-center justify-center rounded-full bg-white-15 py-1"
            >
              <ChevronRight color="#0D0D0D" />
            </button>
          </>
        )}
      </div>
      {images.length > 1 && (
        <p className="text-neutral-600 mt-2 text-sm">
          {safeIdx + 1} / {images.length || 1}
        </p>
      )}
    </div>
  );
}

export default ImageGallery;
